/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	CampaignUpdateWhatsAppAutomationPathParams,
	CampaignUpdateWhatsAppAutomationRequest,
	CampaignUpdateWhatsAppAutomationResponse,
} from '../types/CampaignUpdateWhatsAppAutomation'

/**
 * PATCH /campaigns/:campaign/whatsapp-automation
 * @see backend/nexus/modules/Campaign/Http/Controllers/CampaignController.php CampaignController::updateWhatsAppAutomation
 */
export async function campaignUpdateWhatsAppAutomation(
	campaign: CampaignUpdateWhatsAppAutomationPathParams['campaign'],
	data: CampaignUpdateWhatsAppAutomationRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CampaignUpdateWhatsAppAutomationResponse>> {
	return axiosInstance.patch(`/campaigns/${campaign}/whatsapp-automation`, data, config)
}
